"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLeadFlowDraftById = exports.fetchLeadFlowById = void 0;

var _utils = require("./utils");

var _requestKeys = require("./requestKeys");

var fetchLeadFlowById = (0, _utils.runIfParamDefined)(function (id) {
  (0, _utils.fetch)((0, _utils.buildUrl)("lead-flows/v1/lead-flows/" + id), (0, _requestKeys.getFetchKey)(id));
});
exports.fetchLeadFlowById = fetchLeadFlowById;
var fetchLeadFlowDraftById = (0, _utils.runIfParamDefined)(function (id) {
  (0, _utils.fetch)((0, _utils.buildUrl)("lead-flows/v1/lead-flows/drafts/" + id + "?includeDiff=true"), (0, _requestKeys.getFetchDraftKey)(id));
});
exports.fetchLeadFlowDraftById = fetchLeadFlowDraftById;